import React from "react";
import { Header, Paragraph, Tag, useColorTokens } from "@tvg/design-system";
import { RunnerBI } from "../../../../hooks/useGetRunnerFromBI";
import { MLContainer, OddsContainer, Row } from "./styled-components";

interface OddsProps {
  runnerBI: RunnerBI;
  isDesktop: boolean;
}

const Odds = ({ runnerBI, isDesktop = true }: OddsProps) => {
  const colorTokens = useColorTokens();

  if (!isDesktop && runnerBI.isScratched) {
    return (
      <OddsContainer data-qa-label="race-card-odds-container">
        <Tag
          size="m"
          variant="info"
          label="Scratched"
          qaLabel="race-card-scratched-label"
        />
        <Paragraph
          qaLabel="race-card-morning-line-odd"
          color={colorTokens.content.subtle}
          fontSize="xs"
          mt="space-1"
          opacity={0.4}
        >
          {`ML ${runnerBI.morningLineOdd}`}
        </Paragraph>
      </OddsContainer>
    );
  }

  return (
    <OddsContainer data-qa-label="race-card-odds-container">
      <Row data-qa-label="race-card-fav-tag-odds-container">
        {runnerBI.isFavorite && !runnerBI.isScratched && (
          <Tag size="s" variant="fav" label="FAV" mr="space-3" my="auto" />
        )}
        <Header
          tag="h3"
          fontFamily="medium"
          qaLabel="race-card-current-odd"
          color={colorTokens.content.default}
        >
          {runnerBI.isScratched ? "Scr" : runnerBI.currentOdd}
        </Header>
      </Row>
      <MLContainer isScratched={runnerBI.isScratched}>
        <Paragraph
          qaLabel="race-card-morning-line-odd"
          color={colorTokens.content.subtle}
          fontSize="xs"
        >
          {`ML ${runnerBI.morningLineOdd}`}
        </Paragraph>
      </MLContainer>
    </OddsContainer>
  );
};

export default Odds;
